<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab :key="1" ripple> {{ $t("captainCreatePage.driverTab") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pe-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("captainCreatePage.driverPersonalInfo") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <v-text-field
                      outline
                      v-model="model.first_name"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.firstName")'
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.last_name"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.lastName")'
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.username"
                      :rules="[rules.usernamePhone]"
                      :label='$t("captainCreatePage.phoneNumber")'
                      type="tel"
                      maxlength="9"
                      style="direction: ltr"
                      grow
                      @input="onPhoneInput"
                    >
                      <template v-slot:prepend-inner>
                        <span class="phone-prefix">+963</span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      outline
                      v-model="model.email"
                      :rules="[rules.email]"
                      :label='$t("captainCreatePage.emailAddress")'
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.captain_license_number"
                      :rules="licenceNumberRules"
                      :label='$t("captainCreatePage.licenseNumber") + licenceOptionalSuffix'
                      type="text"
                      grow
                    ></v-text-field>
                    <v-select
                      outline
                      v-model="model.gender"
                      :label='$t("captainCreatePage.gender")'
                      :items="gender"
                      item-text="text"
                      item-value="value"
                      :rules="[rules.required]"
                      dense
                    ></v-select>

                    <v-select
                      outline
                      v-model="model.governorate_id"
                      :label='$t("captainCreatePage.governorate")'
                      :items="governorates"
                      item-text="name_en"
                      item-value="id"
                      :rules="[rules.required]"
                      dense
                    ></v-select>

                    <v-text-field
                      outline
                      v-model="model.nationality_id"
                      :rules="[rules.nationalityId]"
                      :label='$t("captainCreatePage.nationalityId")'
                      type="text"
                      grow
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 grow ps-4>
              <v-layout align-start justify-start column>
                <h1 class="headline">{{ $t("captainCreatePage.documentsInfo") }}</h1>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-layout
                    style="gap: 20px; row-gap: 0px"
                    align-start
                    row
                    xs12
                    wrap
                  >
                    <upload-file
                      class="docs"
                      @change="model.profile_image = $event"
                      :documentName='$t("captainCreatePage.profileImage")'
                    />
                    <upload-file
                      class="docs"
                      @change="model.id_card_front = $event"
                      :documentName='$t("captainCreatePage.idFront")'
                    />
                    <upload-file
                      class="docs"
                      @change="model.id_card_back = $event"
                      :documentName='$t("captainCreatePage.idBack")'
                    />
                    <upload-file
                      class="docs"
                      @change="model.lisence_photo_front = $event"
                      :documentName='$t("captainCreatePage.drivingLicenseFront") + licenceOptionalSuffix'
                    />
                    <upload-file
                      class="docs"
                      @change="model.lisence_photo_back = $event"
                      :documentName='$t("captainCreatePage.drivingLicenseBack") + licenceOptionalSuffix'
                    />
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn @click="next" color="secondary" class="tbtn">{{ $t("captainCreatePage.proceed") }}</v-btn>
        </v-container>
      </v-tab-item>

      <v-tab :key="2" ripple> {{ $t("captainCreatePage.vehicleTab") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pe-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("captainCreatePage.vehicleInformation") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <!--<v-select
                                  outline
                                  v-model="model.brand"
                                  label="Brand"
                                  :items="allBrands"
                                  @change="getTypes"
                                  dense>
                                </v-select>-->

                    <v-select
                      outline
                      v-model="model.vehicle_type"
                      :items="vehicleTypes"
                      item-text="text"
                      item-value="value"
                      :label='$t("captainCreatePage.vehicleType")'
                      dense
                    ></v-select>

                    <v-autocomplete
                      v-model="model.brand"
                      :items="allBrands"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label='$t("captainCreatePage.selectBrand")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                      @change="getTypes"
                    ></v-autocomplete>
                    <!--<v-select
                                  id="ss"
                                  outline
                                  v-model="model.type"
                                  label="Type"
                                  :items="allTypes"
                                  :disabled="!model.brand"
                                  dense>
                                </v-select>-->

                    <v-autocomplete
                      v-model="model.type"
                      :items="allTest"
                      outline
                      hide-no-data
                      item-text="name_en"
                      item-value="id"
                      :label='$t("captainCreatePage.selectModel")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                      :disabled="!model.brand"
                      return-object
                    ></v-autocomplete>
                    <!--<v-select
                                  outline
                                  v-model="model.color"
                                  label="Color"
                                  :items="allColors"
                                  dense>
                                </v-select>-->

                    <v-autocomplete
                      v-model="model.color"
                      :items="allColors"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label='$t("captainCreatePage.selectCarColor")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                    ></v-autocomplete>
                    <v-text-field
                      outline
                      v-model="model.plate_number"
                      :rules="plateRules"
                      :label='$t("captainCreatePage.plateNumber")'
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.car_manufacture_year"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.carManufactureYear")'
                      type="number"
                      grow
                    ></v-text-field>

                    <v-select
                      outline
                      v-model="model.service_ids"
                      :label='$t("captainCreatePage.carServices")'
                      :items="services"
                      item-text="name"
                      item-value="id"
                      multiple
                      :rules="[rules.requiredList]"
                      dense
                    ></v-select>

                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 grow ps-4>
              <v-layout align-start justify-start column>
                <h1 class="headline">{{ $t("captainCreatePage.documentsInfo") }}</h1>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-layout
                    style="gap: 20px; row-gap: 0px"
                    align-start
                    row
                    xs12
                    wrap
                  >
                    <upload-file
                      class="docs"
                      @change="model.car_image = $event"
                      :documentName='$t("captainCreatePage.carImage")'
                    />
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn
            @click="
              addCaptain()
            "
            :loading="loading"
            color="secondary"
            class="tbtn"
            >{{ $t("captainCreatePage.addCaptain") }}</v-btn
          >
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>
<style>
.tbtn {
  float: inline-end;
  margin-top: -40px;
  margin-inline-end: 24px;
  padding: 0px 65px;
}
.docs {
  margin-bottom: 3px;
}

.phone-prefix {
  display: inline-flex;
  align-items: center;
  height: 100%;
  position: relative;
  top: 5px;
  padding-inline-end: 10px;
  margin-inline-end: 10px;
  border-inline-end: 1px solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}
</style>
<script>
import axios from "axios";
import UploadFile from "@/components/widgets/UploadFile.vue";

export default {
  title() {
    return this.$t("captainCreatePage.pageTitleCaptains");
  },
  components: {
    UploadFile,
  },

  data: () => ({
    active: 0,

    loading: false,
    error: false,
    searchQuery: null,
    selectedBrands: [],
    allTest: [],
    brandsList: [],

    colorItem: { id: "", name: "" },
    colorsList: [],

    languageItem: { id: "", name: "" },
    spokenLanguagesList: [],
    spokenLanguagesIds: [],

    requiredDocuments: {},
    model: {
      //captain

      first_name: "",
      last_name: "",
      email: "",
      password: "",
      gender: null,
      username: "", // Phone number
      nationality_id: "",
      governorate_id: null,
      captain_license_number: "",

      profile_image: "",
      lisence_photo_front: "",
      lisence_photo_back: "",
      id_card_front: "",
      id_card_back: "",

      //vehicle

      // CAR | MOTORCYCLE (backend cars.vehicle_type; plate and licence photos
      // are optional for motorcycles).
      vehicle_type: "CAR",
      brand: "",
      type: "",
      color: "",
      plate_number: "",
      car_manufacture_year: "",
      service_ids: [],

      constraints: [], //vehicle constraints
      car_image: "",
    },
    governorates: [],
    allBrands: [],
    allColors: [],
    services: [],
    allLanguages: [],
    allTypes: [],
    car_constraints: [],
    captain_constraints: [],

    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    vehicleTypes() {
      return [
        { text: this.$t("captainCreatePage.vehicleTypeCar"), value: "CAR" },
        { text: this.$t("captainCreatePage.vehicleTypeMotorcycle"), value: "MOTORCYCLE" },
      ];
    },
    isMotorcycle() {
      return this.model.vehicle_type === "MOTORCYCLE";
    },
    // Plate required for cars only (backend: car.plate_number
    // required_unless car.vehicle_type MOTORCYCLE).
    plateRules() {
      return this.isMotorcycle ? [] : [this.rules.required];
    },
    // Owner decision 2026-09-11: a motorcycle captain holds no driving licence,
    // so he has no licence number either (backend: captain.license_number
    // required_unless captain.vehicle_type MOTORCYCLE).
    licenceNumberRules() {
      return this.isMotorcycle ? [] : [this.rules.required];
    },
    licenceOptionalSuffix() {
      return this.isMotorcycle ? " " + this.$t("captainCreatePage.optionalSuffix") : "";
    },
    gender() {
      return [
        { text: this.$t("captainCreatePage.male"), value: 1 },
        { text: this.$t("captainCreatePage.female"), value: 0 },
      ];
    },
    rules() {
      return {
        email: (v) =>
          !v ||
          !!String(v).match(/@/) ||
          this.$t("captainCreatePage.ruleEmail"),
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("captainCreatePage.ruleLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) ||
          this.$t("captainCreatePage.rulePassword"),
        phoneNumber: (v) =>
          (!!v &&
            v.search(
              /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ) !== -1) ||
          this.$t("captainCreatePage.rulePhone"),

        required: (v) => !!v || this.$t("captainCreatePage.ruleRequired"),
        requiredList: (v) =>
          (!!v && v.length > 0) || this.$t("captainCreatePage.ruleRequired"),
        usernamePhone: (v) =>
          (!!v && /^9\d{8}$/.test(v)) ||
          this.$t("captainCreatePage.ruleUsernamePhone"),
        nationalityId: (v) =>
          (!!v && /^\d{11}$/.test(v)) ||
          this.$t("captainCreatePage.ruleNationalityId"),
        numberOfLicense: (v) =>
          !!(v || "").match(/^[0-9]*$/) ||
          this.$t("captainCreatePage.ruleLicense"),
      };
    },
  },
  mounted() {
    // Disabled: stop calling /api/user/language
    // axios.get(this.api.ACTIONS.LANGUAGES).then((response) => {
    //   for (let i = 0; i < response.data.data.length; i++) {
    //     this.allLanguages.push(response.data.data[i].name);
    //     let obj = { id: "", name: "" };
    //     obj.id = response.data.data[i].id;
    //     obj.name = response.data.data[i].name;
    //     this.spokenLanguagesList.push(obj);
    //   }
    // });

    axios.get((this.api.ACTIONS.GOVERNORATE || "governorate")).then((response) => {
      this.governorates = response.data.data;
    });

    axios.get(this.api.ACTIONS.CAR_BRANDS).then((response) => {
      // support both simple array and paginated { data: { data: [...] } }
      const payload = response.data && response.data.data;
      const items = Array.isArray(payload) ? payload : (payload && payload.data) || [];

      items.forEach((brand) => {
        // prefer English name if available
        const name = brand.name_en || brand.name || "";
        this.allBrands.push(name);
        this.brandsList.push({ id: brand.id, name });
      });
    });

    // Disabled: stop calling /api/user/dynamic_constraints
    // axios.get(`dynamic_constraints`).then((data) => {
    //   data.data.data.data.forEach((cons) => {
    //     if(cons.entity_type == 'CAR'){
    //       this.car_constraints.push(cons.constraint_name);
    //     }
    //   });
    // });

    // axios.get(`dynamic_constraints`).then((data) => {
    //   data.data.data.data.forEach((cons) => {
    //     if(cons.entity_type == 'CAPTAIN'){
    //       this.captain_constraints.push('EXT', 'encompt', 'RESA');
    //       this.captain_constraints.push(cons.constraint_name);
    //     }
    //   });

    //   // this.captain_constraints = this.captain_constraints.filter(e => e.constraint_name !== 'PEXT');
    // });

    axios.get(this.api.ACTIONS.COLORS).then((response) => {
      const payload = response.data && response.data.data;
      const items = Array.isArray(payload) ? payload : (payload && payload.data) || [];

      items.forEach((color) => {
        const name = color.name_en || color.name || "";
        this.allColors.push(name);
        this.colorsList.push({ id: color.id, name });
      });
    });

    // perPage: the endpoint paginates (default 10) — without it any service
    // beyond page 1 could never be assigned at creation.
    axios
      .get(this.api.ACTIONS.SERVICES, { params: { perPage: 100 } })
      .then((response) => {
        const payload = response.data && response.data.data;
        const items = Array.isArray(payload) ? payload : (payload && payload.data) || [];

        // Services carry name_en/name_ar (no plain `name` column) — map a
        // display name the way RidesServiceFilter/ServiceCommissionsSettings do,
        // or every dropdown row renders blank.
        this.services = items.map((s) => ({
          ...s,
          name:
            s.name ||
            (this.$i18n && this.$i18n.locale === "ar"
              ? s.name_ar || s.name_en
              : s.name_en || s.name_ar) ||
            `#${s.id}`,
        }));
      })
      .catch((err) => {
        console.log(err.message);
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("captainCreatePage.checkYourInfo"),
          "red"
        );
      });
  },

  methods: {
    onPhoneInput(val) {
      // Keep only digits, max 9 chars (without +963)
      const v = (val || "").toString().replace(/\D/g, "").slice(0, 9);
      if (v !== this.model.username) this.model.username = v;
    },
    testFunction() {
      console.log("ffs");
      console.log(this.model.type.id);
    },
    getTypes() {
      let id = "";
      // console.log(this.model.brand)
      // console.log(this.brandsList)
      for (let i = 0; i < this.brandsList.length; i++) {
        console.log(this.brandsList[i]);
        if (this.brandsList[i].name === this.model.brand)
          id = this.brandsList[i].id;
        // console.log(this.brandsList[i])
      }
      console.log(id);
      const typeUrl = this.api.ACTIONS.CAR_BRAND_MODELS(id);

      this.allTypes = [];
      axios.get(typeUrl).then((response) => {
        const payload = response.data && response.data.data;
        const items = Array.isArray(payload) ? payload : (payload && payload.data) || [];

        this.allTest = items;
      });
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    addCaptain() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        const docsFormData = new FormData();

        // const formData=new FormData();
        // const formData=new FormData();
        // Ensure legacy fields are populated for existing API
        this.model.phone_number = this.model.username;
        this.loading = true;

        // Validate required images. Driving-licence photos are optional for
        // motorcycles (the backend keeps them nullable either way).
        const licenceMissing =
          !this.isMotorcycle && (!this.model.lisence_photo_front || !this.model.lisence_photo_back);
        if (
          !this.model.profile_image ||
          !this.model.id_card_front ||
          !this.model.id_card_back ||
          licenceMissing ||
          !this.model.car_image
        ) {
          window.getApp.$emit("SHOW_TOAST", this.$t("captainCreatePage.uploadAllImages"), "red");
          this.loading = false;
          return;
        }

        formData.append("captain[gender]", this.model.gender);
        formData.append("captain[first_name]", this.model.first_name);
        formData.append("captain[last_name]", this.model.last_name);
        formData.append("captain[username]", this.model.username);
        formData.append("captain[email]", this.model.email);
        // The declared vehicle kind also relaxes the licence-number rule for a
        // motorcycle captain (owner decision 2026-09-11); omit the empty part
        // instead of sending "".
        formData.append("captain[vehicle_type]", this.model.vehicle_type || "CAR");
        if (this.model.captain_license_number)
          formData.append("captain[license_number]", this.model.captain_license_number);
        formData.append("captain[nationality_id]", this.model.nationality_id);
        formData.append("captain[governorate_id]", this.model.governorate_id);

        if (this.model.profile_image) {
          formData.append("captain[profile_image]", this.model.profile_image);
        }

        formData.append("car[brand_model_id]", this.model.type.id);
        for (let i = 0; i < this.colorsList.length; i++) {
          if (this.colorsList[i].name === this.model.color)
            formData.append("car[color_id]", this.colorsList[i].id);
        }

        formData.append("car[vehicle_type]", this.model.vehicle_type || "CAR");
        // A motorcycle may have no plate: omit the part instead of sending "".
        if (this.model.plate_number) formData.append("car[plate_number]", this.model.plate_number);
        formData.append("car[car_manufacture_year]", this.model.car_manufacture_year);
        this.model.service_ids.forEach((id) => formData.append("car[service_ids][]", id));

        // Documents expected by backend
        if (this.model.lisence_photo_front)
          formData.append("lisence_photo_front", this.model.lisence_photo_front);
        if (this.model.lisence_photo_back)
          formData.append("lisence_photo_back", this.model.lisence_photo_back);
        formData.append("id_card_front", this.model.id_card_front);
        formData.append("id_card_back", this.model.id_card_back);

        if (this.model.car_image) {
          formData.append("car[car_picture]", this.model.car_image);
        }

        // Expiry dates currently not used
        // formData.append("captain",formData);
        // formData.append("car",formData);

        this.axios
          .post(this.api.ACTIONS.CAPTAINS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("captainCreatePage.captainAdded"), "green");
            this.$router.push("/drivers");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              // Prefer showing first validation error if present
              const errors = response.data && response.data.errors;
              if (errors) {
                const firstKey = Object.keys(errors)[0];
                const firstMsg =
                  firstKey && errors[firstKey] && errors[firstKey][0];
                if (firstMsg) {
                  window.getApp.$emit("SHOW_TOAST", firstMsg, "red");
                  return;
                }
              }
              window.getApp.$emit(
                "SHOW_TOAST",
                (response.data && response.data.message) ||
                  this.$t("captainCreatePage.checkYourInfo"),
                "red"
              );
              console.log(response.data);
            } else {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("captainCreatePage.checkYourInfo"),
                "red"
              );
            }
          })
          .then(() => (this.loading = false));

        console.log(this.model);
      }
    },
  },
};
</script>
